
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.071 1H3.93C2.9 1 2 1.875 2 2.875v16.25c0 1 .9 1.875 1.929 1.875H18.07C19.1 21 20 20.125 20 19.125V2.875c0-1-.9-1.875-1.929-1.875zM7.143 18c0 .25-.257.5-.514.5H5.086c-.257 0-.515-.25-.515-.5v-1.5c0-.25.258-.5.515-.5h1.543c.257 0 .514.25.514.5V18zm0-5c0 .25-.257.5-.514.5H5.086c-.257 0-.515-.25-.515-.5v-1.5c0-.25.258-.5.515-.5h1.543c.257 0 .514.25.514.5V13zm5.143 5c0 .25-.257.5-.515.5H10.23c-.258 0-.515-.25-.515-.5v-1.5c0-.25.257-.5.515-.5h1.542c.258 0 .515.25.515.5V18zm0-5c0 .25-.257.5-.515.5H10.23c-.258 0-.515-.25-.515-.5v-1.5c0-.25.257-.5.515-.5h1.542c.258 0 .515.25.515.5V13zm5.143 5c0 .25-.258.5-.515.5h-1.543c-.257 0-.514-.25-.514-.5v-6.5c0-.25.257-.5.514-.5h1.543c.257 0 .515.25.515.5V18zm0-10c0 .25-.258.5-.515.5H5.086c-.257 0-.515-.25-.515-.5V4c0-.25.258-.5.515-.5h11.828c.257 0 .515.25.515.5v4z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_mesa_de_trabalho.svg